import React, { Component } from 'react';
import Image from '../image/image';


class ImageHead extends Component {
  render() {
    const { style, className, media, imageStyle } = this.props;
    return (
      <Image style={style} media={media} className={className} imageStyle={imageStyle} />
    )
  }   
}

export default ImageHead;
